import { ServerResponseData } from 'app/models/api/response';
import { Translation } from 'app/models/api/translation';
import { BaseParser } from 'app/services/api/parsers/base-parser';
import { ParserMap } from 'app/services/api/parsers/response-parser';

export class TranslationParser extends BaseParser {
    parse(data: ServerResponseData, _included: ServerResponseData[], _parsersMap: ParserMap) {
        const item = super.parseBase(Translation, data);
        return item;
    }
}
